
/** MCD APIエラー情報 */
export type McdApiErrorInfo = {
  errorCode: string,
  message: string,
  stackTrace?: string,
}

/** MCDAPIレスポンス */
export interface McdApiResponse<TResponseBody> {
  body?: TResponseBody,
  isError: boolean,
  errorInfo?: McdApiErrorInfo
}

/** APIエラーの状態管理キー */
export enum McdApiErrorStateKeys {
  /** MCD APIエラー */
  McdApiError = 'McdApiError',
  /** 通信エラー */
  ApiCommunicationError = 'ApiCommunicationError',
}

/** GETリクエストパラメータの生成 */
export const createGetApiParams = (params?: {}) => {
  // const qt = (getMcdObject().envConfig.backend === Backend.PaaS)
  const qt = false
  return { _qt: qt, ...params }
}

/** POSTリクエストパラメータの生成 */
export const createPostApiBody = (body?: {}) => {
  // const qt = (getMcdObject().envConfig.backend === Backend.PaaS)
  const qt = false
  return {
    qt: qt,
    body: body,
  }
}

/** APIエラー判定 */
export const validateApiError = (response: any) => {
  if (response.data.isError) {
    throw response.data
  }
}
